export const AdminInquiryConst = {
  FETCH_MY_INQUIRIES_REQUEST: "FETCH_MY_INQUIRIES_REQUEST",
  FETCH_MY_INQUIRIES_SUCCESS: "FETCH_MY_INQUIRIES_SUCCESS",
  FETCH_MY_INQUIRIES_FAIL: "FETCH_MY_INQUIRIES_FAIL",

  CREATE_INQUIRY_REQUEST: "CREATE_INQUIRY_REQUEST",
  CREATE_INQUIRY_SUCCESS: "CREATE_INQUIRY_SUCCESS",
  CREATE_INQUIRY_FAIL: "CREATE_INQUIRY_FAIL",

  FETCH_MESSAGES_REQUEST: "FETCH_MESSAGES_REQUEST",
  FETCH_MESSAGES_SUCCESS: "FETCH_MESSAGES_SUCCESS",
  FETCH_MESSAGES_FAIL: "FETCH_MESSAGES_FAIL",

  SEND_MESSAGE_REQUEST: "SEND_MESSAGE_REQUEST",
  SEND_MESSAGE_SUCCESS: "SEND_MESSAGE_SUCCESS",
  SEND_MESSAGE_FAIL: "SEND_MESSAGE_FAIL",

  CLEAR_ACTION: "ADMIN_INQUIRY_CLEAR_ACTION",
};
